export const literals = {
  reception: "Recepción",
  garage: "Taller",
  storeHouse: "Almacén",
  leaveOrder: "Salir de la orden",
  newOrder: "Nueva orden",
  continue: "Continuar",
  garageEnter: "Entrada Taller",
  findings: "Findings",
  garageExit: "Salida Taller",
  step: "Paso",
  orderNumber: "Número de orden",
  required: "Campo obligatorio",
  scan: "Escanear",
  scanBanCode: "Escanear código de barras",
  cancel: "Cancelar",
  orderNumberFormat: "Debe tener entre 10 y 12 dígitos",
  orderExample: "Ej: 12345678910",
  leaveOrderQuestion:
    "Al salir de la orden perderá los datos registrados hasta ahora. ¿Está seguro?",
  leave: "Salir",
  addPhoto: "Añadir foto",
  seeOrder: "Ver orden",
  takePhoto: "Fotografiar",
  visibleForClients: "Visibles para los clientes",
  order: "Orden",
  description: "Descripción",
  cleanDescription: "Limpiar descripción",
  uploadMorePhotos: "Subir otro grupo de fotos",
  seeAllPhotos: "Ver todas las fotos de la orden",
  saveChanges: "Guardar cambios",
  photos: "Fotos",
  clientVisible: "Visible cliente",
  confirmation: "Confirmación",
  confirmText:
    "Una vez guardada la orden, la información no podrá ser modificada. Por favor, verifique que todos los datos sean correctos antes de confirmar.",
  confirmAndCloseOrder: "Confirmar y cerrar orden",
  orderOut: "Part# Salida",
  serialOutLabel: "Serial# Salida",
  docu9R1: "Documento 9R1",
  goBackOrder: "Volver a la orden",
  orderExit: "¿Quiere salir de la orden?",
  orderExitText:
    "Al salir de la orden perderá los datos registrados hasta ahora. ¿Está seguro?",
  exit: "Salir",
  chooseAnOption: "Elija una opción",
  r9Format: "Debe tener 10 dígitos",
  outNumberExample: "Ej: serialdata",
  advancedSearch: "Búsqueda avanzada",
  moreOptions: "Más opciones",
  search: "Buscar",
  workstation: "Puesto",
  customerOrderNoServ: "Pedido cliente NOSERV (RO)",
  customerOrderServ: "Pedido cliente SERV",
  serialIn: "Serial# Entrada",
  serialOut: "Serial# Salida",
  partIn: "Part# Entrada",
  partOut: "Part# Salida",
  document9R1: "Documento 9R1",
  client: "Cliente",
  workOrder: "Orden de trabajo",
  visibleClient: "Visible cliente",
  packaging: "Embalaje",
  ownPackaging: "Embalaje propio",
  correctPackaging: "Embalaje correcto",
  damagedPackaging: "Embalaje dañado",
  packagingReference: "Referencia de embalaje",
  dateFrom: "Fecha desde",
  dateTo: "Fecha hasta",
  date: "Fecha",
  showOptions: "Desplegar opciones",
  hideOptions: "Ocultar opciones",
  noServCell: "Célula NOSERV",
  inNoServ: "Entrada NOSERV",
  outNoServ: "Salida NOSERV",
  inStoreHouse: "Entrada almacén",
  outStoreHouse: "Salida almacén",
  yes: "Sí",
  no: "No",
  noAnswer: "N/A",
  photosList: "Listado de fotos",
  filter: "Filtrar",
  aProblem: "Ha habido un problema",
  uploadNoPossible:
    "No se han podido subir las fotos. Por favor, inténtelo más tarde",
  correctUpload: "Subida correcta",
  savedPicturesPart1:
    "Todas las fotos han sido almacenadas de forma correcta. En total se han guardado",
  savedOnePicture: "La imagen ha sido almacenada de forma correcta",
  images: "imágenes",
  loading: "Cargando...",
  respondRequest: "Responder petición",
  requestDate: "Fecha petición",
  name: "Nombre",
  photo: "Foto",
  customerOrder: "Pedido cliente",
  noServ: "NOSERV",
  packagingRef: "Ref. embalaje",
  wishDeletePhoto: "¿Desea borrar esta foto?",
  group: "Grupo",
  delete: "Borrar",
  download: "Descargar",
  area: "Área",
  selectOption: "Selecciona una opción",
  photoDetail: "Detalle de foto",
  selectBothDates: "Es obligatorio seleccionar ambas fechas o ninguna.",
  seePhotos: "Ver fotos",
  homePage: "Inicio",
  errorDateRange: "Desde debe ser anterior a Hasta",
  needFromDate: "Seleccione también Fecha desde",
  needEndDate: "Seleccione también Fecha hasta",
  twoOrNoDate: "Seleccione las dos fechas o ninguna",
  customerExample: "Ej: 123456",
  return: "Atrás",
  deletePhoto: "Borrar foto",
  sendDeleteRequest: "Enviar petición",
  confirmDeletePhoto: "Se borrará la foto. ¿Está seguro?",
  confirmRequestDeletePhoto:
    "No tiene permisos para borrar esta foto. Se enviará la petición a un supervisor para que pueda borrar la foto. ¿Desea mandar la petición?",
  errorDeletingPhoto: "Error al borrar la foto",
  orderIn: "Part# Entrada",
  serialInLabel: "Serial# Entrada",
  generalOverview: "Vista general",
  idLabel: "ID label",
  mishandling: "Mishandling",
  misuse: "Misuse",
  others: "Others",
  extraInformation: "Información extra",
  discardOrder: "Descartar orden",
  confirmAndContiue: "Confirmar y continuar a",
  exitReception: "Salida recepción",
  confirmAndExit: "Confirmar y salir",
  customerFormat: "Debe tener entre 3 y 6 dígitos",
  receptionEnter: "Entrada recepción",
  receptionExit: "Salida recepción",
  workOrderHeader: "Orden trabajo",
  packageReference: "Ref. embalaje",
  discardAlert:
    "Al descartar orden perderá los datos registrados hasta ahora ¿Esta seguro?",
  modificatedAlert: "Dato modificado. Busque de nuevo.",
  getInfoError:
    "No ha sido posible obtener la información buscada. Por favor, inténtelo más tarde.",
  notFoundData: "Dato no encontrado",
  noRoOrder:
    "No se ha encontrado ninguna orden con ese Pedido cliente NOSERV (RO). Por favor, verifique el dato e inténtelo de nuevo.",
  noSapOrder:
    "No se ha encontrado ninguna orden con este número. Por favor, verifique el dato e inténtelo de nuevo.",
  notFound: "Not found",
  errorNotFound: "Error: Not found",
  cleanExtrainfo: "Limpiar información",
  sameInData:
    "Ya existe una orden con este número e igual Serial# Entrada y Part# Entrada. Puse continuar si quiere seguir tomando fotos",
  sameSerialIn:
    "Ya existe una orden con este número e igual Serial# Entrada. Puse continuar si quiere seguir tomando fotos",
  samePartIn:
    "Ya existe una orden con este número e igual Part# Entrada. Puse continuar si quiere seguir tomando fotos",
  diferentInData:
    "Ya existe una orden con este número pero con otros Serial# Entrada y Part# Entrada. Modifique los datos si quiere continuar.",
  diferentSerialIn:
    "Ya existe una orden con este número pero con otro Serial# Entrada. Modifique los datos si quiere continuar.",
  diferentPartIn:
    "Ya existe una orden con este número pero con otro Part# Entrada. Modifique los datos si quiere continuar.",
  noValidData: "Información no válida",
  usedData: "Datos ya usados",
  diferentOrderWith9r1:
    "El Documento 9R1 introducido está vinculado a una orden diferente. Si quiere terminar el proceso, modifique el dato, por favor.",
  sameOrderAnd9r1:
    "Ya existen fotos guardadas para esta orden con este Documento 9R1. Si desea seguir guardando, pulse contiuar.",
  sameOrderButOther9r1:
    "Ya existen fotos guardadas para esta orden, pero con otro Documento 9R1. Si desea seguir guardando, pulse contiuar.",
  existingOrder: "Orden ya existente",
  editPackaging: "Editar embalaje",
  edit: "Editar",
  oneVisibleForClients: "Visible para los clientes",
  onePictureChanges:
    "Los cambios se aplicarán sólo a la foto seleccionada, ¿desea continuar?",
  severalPictureChanges1: "Los cambios se aplicarán a ",
  severalPictureChanges2: " fotografías en total",
  severalPictureChanges3: ", ¿desea continuar?",
  getNecesaryInfoError:
    "No ha sido posible obtener la información necesaria para continuar el proceso. Por favor, inténtelo más tarde.",
  noPossibleSaveChanges:
    "No ha sido posible guardar los cambios introducidos. Por favor, inténtelo más tarde.",
  changesOk: "Cambios guardados",
  complettedChanges:
    "Las modificaciones se han completado con éxito. Puede seguir consultando imágenes si lo desea",
  basicSearch: "Búsqueda",
  packagingArea: "Packaging",
  sendAction: "Envío",
  preSendAction: "Pre-envío",
  iberiaPackaging: "Emb. proporcionado por IBERIA",
  noData: "No hay datos disponibles",
  noDataInOrder:
    "No hay una orden con esos datos, pero si quiere seguir con el proceso, puede continuar.",
  own: "Propio",
  correct: "Correcto",
  damaged: "Dañado",
  confirmShortText:
    "Una vez guardada la orden, la información no podrá ser modificada.",
  completeBeforeSave:
    "Complete la siguiente información antes de guardar la orden. Una vez guardada la orden, la información no podrá ser modificada.",
  sentWithOWnPackage: "¿Se ha enviado con embalaje propio?",
  iberiaPackagingConfirm: "Embalaje proporcionado por IBERIA",
  ownPackagingOut: "Embalaje propio salida",
  iberiaPackagingOut: "Embalaje proporcionado por Iberia",
  success: "¡Éxito!",
  requestCompleted: "Solicitud enviada correctamente",
  exits: "Salidas",
  presendsAction: "Preenvíos",
  packagingAction: "Packaging",
  backToHome: "Volver a inicio",
  notAllowed: "No tiene permisos para responder",
  goBackList: "Volver al listado",
  hasRequestDeletion:
    "Esta foto tiene una petición de borrado pendiente de respuesta",
  hasRequestEdition:
    "Esta foto tiene una petición de edición pendiente de respuesta",
  uploadPhotoGroup: "Subir un grupo de fotos",
  requestDelete: "Solicitar borrado",
  requestEdition: "Solicitar edición",
  requestError:
    "No se ha podido enviar su petición. Por favor, inténtelo más tarde.",
  clearText: "Borrar texto",
  askedEdition: "Edición que se solicita",
  sendPetition: "Enviar petición",
  sentPetition: "Petición eviada",
  sentPetitionText: "Su solicitud de edición ha sido registrada con éxito.",
  type: "Tipo",
  noPenndingRequests: "No hay solicitudes pendientes",
  rejectPetition: "Rechazar petición",
  acceptPetition: "Aceptar petición",
  completedProcess: "Proceso finalizado",
  deletionPhoto: "Se ha borrado la fotografía ",
  deletionRejected: "Se ha rechazado el borrado de la fotografía ",
  requestedBy: "Solicitud de: ",
  deletionPetition: "Borrado de la fotografía",
  edition: "Edición: ",
  all: "Todos",
  wishEditPhoto: "¿Desea editar esta foto?",
  request: "Petición",
  editedPhoto: "Se han editado los datos.",
  editionRejected: "Se ha rechazado la edición de datos",
  rejectedPetition: "Petición rechazada",
  noChargedImage: "No se ha podido cargar la imagen",
  applyFilters: "Aplicar filtros",
  clearFilters: "Limpiar filtros",
  filterRequests: "Filtrar solicitudes",
  returnToOrigin: "Devolución a origen",
  returnToOriginLabel: "Devolución a Origen",
  wantContinueClic: "Si desea seguir con el proceso, pulse continuar.",
  sendToExits: "Enviar a Salidas",
  selectDestination: "Seleccionar destino",
  pageElements: "Elementos por página",
};
